import { useState } from 'react'
import { createContainer } from 'unstated-next'

import { FitModel } from '../../../../../types/graphql'

export type UseFitModelStateContainerProps = {
  fitModel?: FitModel
}

const useFitModelStateContainer = (props: UseFitModelStateContainerProps | undefined) => {
  const { fitModel: initialFitModel } = props ?? {}

  const [fitModel, setFitModel] = useState<FitModel | undefined>(() => initialFitModel)

  return {
    fitModel,
    setFitModel,
  }
}

export const FitModelStateContainer = createContainer(useFitModelStateContainer)
